var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"py-4"},[_c('h3',[_vm._v(_vm._s(_vm.metricName))]),(_vm.dataCollection)?_c('bar-chart',{attrs:{"chart-data":_vm.dataCollection,"options":_vm.options}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }